import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { AE_COMMAND_CENTER_QUALITY_ACTION_TYPE } from '../actions/aeCommandCenterQuality.actions';

// null = not loaded / not available (roster 404 with the flag off, or 403 auth
// gap). A loaded roster is an array (possibly empty when the AE owns no brokers).
const initialState = null;

const aeCommandCenterQualityReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case AE_COMMAND_CENTER_QUALITY_ACTION_TYPE.SET_BROKERS:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default aeCommandCenterQualityReducer;
